import { Card, CardContent } from "~/components/reusable/Card"
import { TrendDown } from "@phosphor-icons/react"
import { formatNumber } from "~/utils/formatting"
import { sumBy } from "lodash"
import {
  SimpleTable,
  SimpleTableBody,
  SimpleTableCell,
  SimpleTableHead,
  SimpleTableHeader,
  SimpleTableRow,
} from "~/components/reusable/Table"
import { useMemo } from "react"
import LoadingOverlay from "../../reusable/LoadingOverlay"
import { Separator } from "../../reusable/Separator"
import { formatName } from "~/utils/namingUtils"

type Props = {
  bottomProducts: { name: string; value: number }[]
  isLoading: boolean
}

const BottomProductsCard = ({ bottomProducts, isLoading }: Props) => {
  const bottomProductsSum = useMemo(() => sumBy(bottomProducts, "value"), [bottomProducts])

  return (
    <Card className="w-full flex flex-col">
      <CardContent>
        <div className="flex flex-col gap-1">
          <div className="flex items-center gap-2">
            <TrendDown className="text-fg-subtle" />
            <div className="label-base text-fg-subtle">Worst sellers</div>
          </div>

          <div className="flex items-end gap-1">
            <div className="heading-sm">
              {bottomProductsSum ? formatNumber(bottomProductsSum, 0) : "-"}
            </div>
            <p className="paragraph-base pb-[2px]">Units</p>
          </div>
        </div>
      </CardContent>
      <Separator />
      <CardContent>
        <SimpleTable>
          <SimpleTableHeader>
            <SimpleTableRow>
              <SimpleTableHead>Product</SimpleTableHead>
              <SimpleTableHead>{formatName("preorder", true, true)}</SimpleTableHead>
            </SimpleTableRow>
          </SimpleTableHeader>
          <SimpleTableBody>
            {isLoading && (
              <SimpleTableRow>
                <SimpleTableCell colSpan={2}>
                  <LoadingOverlay />
                </SimpleTableCell>
              </SimpleTableRow>
            )}

            {!isLoading && (!bottomProducts || bottomProducts.length === 0) && (
              <SimpleTableRow>
                <SimpleTableCell colSpan={2}>
                  <div className="text-center mt-2 label-base">
                    <p>No bottom products data available for the selected collection.</p>
                  </div>
                </SimpleTableCell>
              </SimpleTableRow>
            )}

            {bottomProducts?.map((p, index) => {
              return (
                <SimpleTableRow key={p.name}>
                  <SimpleTableCell>
                    {index + 1}. {p.name}
                  </SimpleTableCell>
                  <SimpleTableCell className="text-fg-subtle">
                    {formatNumber(p.value)}
                  </SimpleTableCell>
                </SimpleTableRow>
              )
            })}
          </SimpleTableBody>
        </SimpleTable>
      </CardContent>
    </Card>
  )
}

export default BottomProductsCard
